import { expVal } from '@atlassian/jira-feature-experiments';

const JiraSprintRollupsRelayprovider = {
	get(): boolean {
		return expVal('jira_timeline_rollups', 'isEnabled', false);
	},
};

export default JiraSprintRollupsRelayprovider;
